import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TerminalLifecycleRepository } from '@app/domain/ports/tpv/terminal-lifecycle.repository';
import { UpdateTerminalRequest } from '@app/data/dtos/tpv/terminal-update.dto';
import { tpvUrl } from '@app/data/tpv/tpv-api.config';
import { TpvEnvelope } from '@app/data/tpv/tpv-envelope';

/**
 * Implementación HTTP del ciclo de vida de terminales (§4).
 *
 * Auth: NO setea cabeceras manuales. El `authInterceptor` agrega el Bearer y
 * maneja 401/refresh; el `ApiKeyInterceptor` agrega el `x-api-key`. Estos
 * endpoints no requieren `Idempotency-Key`.
 *
 * `idTerminal` es la clave natural de la terminal (string libre, NO UUID).
 */
@Injectable()
export class TerminalLifecycleRemoteDataSource extends TerminalLifecycleRepository {
  private readonly http = inject(HttpClient);

  override updateTerminal(
    idTerminal: string,
    payload: UpdateTerminalRequest,
  ): Observable<void> {
    return this.http
      .patch<TpvEnvelope<unknown>>(tpvUrl(`terminals/${idTerminal}/`), payload)
      .pipe(map(() => void 0));
  }

  override deleteTerminal(idTerminal: string): Observable<void> {
    return this.http
      .delete<TpvEnvelope<unknown>>(tpvUrl(`terminals/${idTerminal}/`))
      .pipe(map(() => void 0));
  }
}
